import { render } from "./VideoFiles.vue?vue&type=template&id=7669ae83&scoped=true"
import script from "./VideoFiles.vue?vue&type=script&lang=js"
export * from "./VideoFiles.vue?vue&type=script&lang=js"

import "./VideoFiles.vue?vue&type=style&index=0&id=7669ae83&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7669ae83"]])

export default __exports__